import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Broadcasts whether a side panel (SOA "Manage Footnotes" or ECB
 * "Collaboration Comments") is open, so the common header can collapse the
 * Share and Back to Workspace buttons into round icon-only buttons when the
 * available width shrinks.
 */
@Injectable({ providedIn: 'root' })
export class SidePanelService {
    private readonly _isOpen = new BehaviorSubject<boolean>(false);

    /** Emits the current side-panel open state */
    readonly isOpen$ = this._isOpen.asObservable();

    setOpen(open: boolean): void {
        this._isOpen.next(open);
    }
}
